export function Tabs({
  activeTab,
  setActiveTab,
  isNewEmployee = false,
  isRejoinPrefill = false,
  onCloseForm,
  isEmployeeView = false,
  employee = {},
  availableTabs = null, // New prop for employee view
}) {
  // ✅ Determine PF applicability safely from multiple sources
  const isPfApplicable =
    employee?.pfApplicable === true ||
    employee?.orgDetails?.pfApplicable === true ||
    employee?.statutoryApplicability?.pfApplicable === true;

  // ✅ Determine ESI applicability safely from multiple sources
  const isEsiApplicable =
    employee?.esiApplicable === true ||
    employee?.orgDetails?.esiApplicable === true ||
    employee?.statutoryApplicability?.esiApplicable === true;

  // ✅ Tabs list (Statutory Details included if PF or ESI is applicable)
  const tabs = [
    { id: "org", label: "Org Details" },
    { id: "personal", label: "Personal" },
    { id: "family", label: "Family" },
    { id: "bank", label: "Bank" },
    { id: "educational", label: "Education" },
    { id: "professional", label: "Profession" },
    ...(isPfApplicable || isEsiApplicable
      ? [{ id: "statutory", label: "Statutory Details" }]
      : []),
    { id: "documents", label: "Documents" },
  ];
  const darkMode = false;

  return (
    <div className="flex border-b border-gray-200 relative z-10 bg-white h-12">
      {tabs.map((tab) => {
        const isDisabled = isNewEmployee && !isRejoinPrefill && tab.id !== "org";
        
        // For employee view, disable tabs that aren't available yet
        const isEmployeeTabDisabled = isEmployeeView && availableTabs && !availableTabs.includes(tab.id);

        return (
          <button
            key={tab.id}
            className={`py-3 px-4 text-sm font-medium transition-colors ${
              activeTab === tab.id
                ? `${
                      darkMode
                        ? "bg-[#BB86FC] text-white border-b-2 border-[#BB86FC]"
                        : "bg-blue-500 text-white border-b-2 border-blue-600"
                    }`
                : isDisabled || isEmployeeTabDisabled
                ? "text-gray-400 cursor-not-allowed bg-gray-50"
                : "text-gray-600 hover:bg-gray-50 hover:text-gray-800"
            }`}
            onClick={() =>
              !isDisabled && !isEmployeeTabDisabled && setActiveTab(tab.id)
            }
            disabled={isDisabled || isEmployeeTabDisabled}
            title={
              isDisabled
                ? "Complete Organization Details first"
                : isEmployeeTabDisabled
                ? "Complete previous sections to unlock this tab"
                : ""
            }
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
